<template>
  <a-list size="small" :data-source="data">
    <a-list-item slot="renderItem" slot-scope="item">
      <span class="row-name">{{ item[0] }}</span>
      <span class="row-value">{{ item[1] }}</span>
    </a-list-item>
  </a-list>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

const exceptions = [
  'enabled',
  'installType',
  'status',
  'trigger',
  'updateId',
  'updateUrl',
  'userId',
];

export default {
  computed: {
    ...mapGetters(['digitalFingerprint']),
    data() {
      return Object.entries(this.digitalFingerprint)
        .filter(([key]) => !exceptions.includes(key))
        .sort(([key1], [key2]) => key1.localeCompare(key2))
        .map(([key, value]) => [
          this.getTransformedKey(key),
          this.getTransformedValue({ [key]: value }),
        ]);
    },
  },
  methods: {
    getTransformedKey(key) {
      const transformedKeys = {
        OSname: 'os name',
        query: 'IP',
      };

      return transformedKeys[key] || key.replace(/([A-Z])/g, ' $1');
    },
    getTransformedValue(item) {
      const transformers = {
        updateTime: (time) => moment(time).locale('en').format('LLLL'),
      };

      const [[key, value]] = Object.entries(item);
      const transformer = transformers[key];

      return (transformer && transformer(value)) || value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.row-name {
  text-transform: uppercase;
  color: $grey;
  flex: 1;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.71px;
  line-height: 14px;
}

.row-value {
  color: $dark-grey;
  flex: 2;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
}
</style>
